import React from "react";
import { ShieldAlert } from "lucide-react";

const DISCLAIMER_TEXT = "Disclaimer: Please note that Adukoo serves as an online marketplace and intermediary, merely providing the platform to listers to list their businesses. The products listed on our platform are provided by third parties (i.e., listers) with the pricing marked at their discretion. We do not verify the authenticity or quality of these products, and we make no representations or warranties regarding their genuineness. By using our platform, you acknowledge that any purchase made is at your own risk, and we are not liable for any issues related to product authenticity, quality, or performance. We encourage users to exercise caution and discretion before making any payments to listers.";

/**
 * Reusable platform disclaimer.
 * - variant="ad" → compact box under every listing detail page (light card, navy text)
 * - variant="site" → footer strip rendered above the copyright row (dark, low-emphasis)
 */
export default function Disclaimer({ variant = "site" }) {
    if (variant === "ad") {
        return (
            <div data-testid="ad-disclaimer" className="mt-6 bg-aduku-bg border border-aduku-border rounded-xl p-4">
                <div className="flex items-start gap-2.5">
                    <ShieldAlert className="w-4 h-4 text-aduku-navy/55 shrink-0 mt-0.5" />
                    <p className="text-[11px] leading-relaxed text-aduku-navy/65">
                        {DISCLAIMER_TEXT}
                    </p>
                </div>
            </div>
        );
    }
    // site footer variant — collapsed into a single line that expands on tap
    // so casual visitors don't get a wall of legalese in the footer.
    return (
        <details data-testid="site-disclaimer" className="mt-6 pt-4 border-t border-white/15">
            <summary className="cursor-pointer text-[11px] uppercase tracking-wider text-white/55 hover:text-white/80 font-semibold inline-flex items-center gap-1.5">
                <ShieldAlert className="w-3.5 h-3.5" /> Platform disclaimer
            </summary>
            <p data-testid="site-disclaimer-text" className="mt-2 text-[12px] leading-relaxed text-white/70 max-w-4xl">
                {DISCLAIMER_TEXT}
            </p>
        </details>
    );
}
